import { render, staticRenderFns } from "./ActionDelete.vue?vue&type=template&id=0a4fed98&"
import script from "./ActionDelete.vue?vue&type=script&lang=ts&"
export * from "./ActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4fed98')) {
      api.createRecord('0a4fed98', component.options)
    } else {
      api.reload('0a4fed98', component.options)
    }
    module.hot.accept("./ActionDelete.vue?vue&type=template&id=0a4fed98&", function () {
      api.rerender('0a4fed98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/v2/ActionDelete.vue"
export default component.exports